import React, { useContext, forwardRef } from 'react';
import { ModalContext } from '../../context/ModalContext';

interface ModalTriggerContainerProps {
  children: React.ReactNode;
  width?: string;
}

const ModalTriggerContainer = forwardRef<
  HTMLDivElement,
  ModalTriggerContainerProps
>(({ children, width }, ref) => {
  const modalContext = useContext(ModalContext);

  const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    modalContext?.displayModal(true);
  };

  return (
    <div
      ref={ref}
      onClick={onClick}
      style={{ width: `fit-content ${width}`, cursor: 'pointer' }}
    >
      {children}
    </div>
  );
});

export default ModalTriggerContainer;
